import { API } from '../utils/amplifyWrapper';

export const trackMixpanelService = (data) => {
    
    return API.post(
        'main',
        `/trackmixpanel`, 
        {
            body : data,
            headers: { "Content-Type":"application/json" }
        }
    ).then(resp => {

        return resp.data

    }).catch((error)=>{

        console.log('error', error)

        return error

    });
}

// GROW-81: fire LOGIN at most once per browser per calendar day, so the count is
// "distinct returning users", not one per page reload. Session resume runs on every
// app load, and an interactive sign-in is often followed by a session restore (e.g.
// the Google callback redirect remounts the app) — both would otherwise double-count.
// All three sign-in paths (email, Google, session resume) share this key.
const LOGIN_TRACKED_KEY = 'l2it_login_tracked_date';
const loginDayKey = () => new Date().toISOString().slice(0, 10); // YYYY-MM-DD (UTC)

// Consume today's login slot WITHOUT emitting — call this on signup so a brand-new
// user isn't counted as a returning login on their signup day.
export const markLoginTrackedForToday = () => {
    try { localStorage.setItem(LOGIN_TRACKED_KEY, loginDayKey()); } catch (_) { /* storage blocked */ }
};

export const trackLoginOncePerDay = (eventData = {}) => {
    try {
        if (localStorage.getItem(LOGIN_TRACKED_KEY) === loginDayKey()) {
            return Promise.resolve(); // already counted a login for this browser today
        }
        localStorage.setItem(LOGIN_TRACKED_KEY, loginDayKey());
    } catch (_) {
        // localStorage unavailable (private mode) — proceed best-effort; better to risk an
        // occasional double-count than to silently drop the login entirely.
    }
    return trackMixpanelService({ body: { eventName: 'LOGIN', eventData } });
}